import React, { useEffect } from 'react';
import ScrollReveal from 'scrollreveal';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  useLocation,
} from 'react-router-dom';

import MainContent from './MainContent';
import About from './About';
import TaxStrategy from './TaxStrategy';
import S172Statements from './S172Statements';
import SlaveryBCCAP from './SlaveryBCCAP';
import SlaveryL51N from './SlaveryL51N';
import Cookies from './Cookies';

import ScrollToTop from './ScrollToTop';
import './App.css';

function AppContent() {
  const location = useLocation();

  useEffect(() => {
    // Re-initialize ScrollReveal on route change
    ScrollReveal().reveal('.reveal', {
      distance: '40px',
      duration: 800,
      easing: 'ease-out',
      origin: 'bottom',
      interval: 100,
      opacity: 0,
      reset: false,
      cleanup: true, // Optional: removes previous reveals before reapplying
    });
  }, [location.pathname]);

  return (
    
      <div style={{backgroundColor: '#ffffff'}} className="App">
        <div className='wholepage'>
          <div className='logo reveal'>
            <Link to="/"><img className='image' src='/images/logo.svg' /></Link>
          </div>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<MainContent />} />
            <Route path="/about" element={<About />} />
            <Route path="/taxstrategy" element={<TaxStrategy />} />
            <Route path="/s172" element={<S172Statements />} />
            <Route path="/slaverybccap" element={<SlaveryBCCAP />} />
            <Route path="/slaveryl51n" element={<SlaveryL51N />} />
            <Route path="/cookies" element={<Cookies />} />
          
        </Routes>
          
          <div className='footer'>
            <div className='footercol reveal'>
              <p className='bluetext'>Contact</p>
              <p>+44 (0)20 3978 8900<br />
              <a href="mailto:information@bccap.com">information@bccap.com</a></p>
            </div>
            <div className='footercol'>
              <ul className='footerlinks'>
                <li className='reveal'><Link to="/about">About</Link></li>
                <li className='reveal'><Link to="/taxstrategy">Tax Strategy</Link></li>
                <li className='reveal'><Link to="/s172">S172 Statements</Link></li>
                <li className='reveal'><Link to="/slaverybccap">Modern Slavery BCCAP</Link></li>
                <li className='reveal'><Link to="/slaveryl51n">Modern Slavery L51N</Link></li>
                <li className='reveal'><Link to="/cookies">Cookie Policy</Link></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      
      
      
      
    
  );
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <AppContent />
    </Router>
  );
}

export default App;
